import { SnackbarProvider } from 'notistack';
import { NotistackToast } from '@/context/notification/notistack-toast.component';

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <SnackbarProvider
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      autoHideDuration={7000}
      Components={{
        toast: NotistackToast,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
